export default __webpack_public_path__ + "static/media/edit.1bc357e1.svg";